import { useGetLoggedInUserQuery } from '../redux/api/users';

/**
 * Groups allowed to set the Inspection Sample Labeling flag (PTB-6619).
 * Mirrors the backend INSPECTION_LABELING_MANAGE_GROUPS setting (default
 * "Shop Managers,Shop Manager"). Both spellings are accepted because the group
 * name drifts across environments, and a manager locked out by a spelling
 * would look like the feature is broken.
 */
const LABELING_MANAGE_GROUPS = ['Shop Managers', 'Shop Manager'];

/**
 * Returns whether the logged-in user may decide that a job requires Inspection
 * Sample Labeling. Superusers always can. Fails closed while the user is still
 * loading.
 *
 * Only the decision is gated. Honouring the requirement is not: the hand and
 * Keyence confirmations, the delivery confirmation and the Form 71 kitting tag
 * are what the flag exists to produce, and they stay open to every role.
 */
export const useCanManageInspectionSampleLabeling = (): boolean => {
	const { data: user } = useGetLoggedInUserQuery();

	if (!user) {
		return false;
	}

	if (user.is_superuser) {
		return true;
	}

	return (user.groups || []).some((group) =>
		LABELING_MANAGE_GROUPS.includes(group)
	);
};

export default useCanManageInspectionSampleLabeling;
